/**
 * Middleware die sicherstellt, dass die App initialisiert ist, bevor eine Seite geladen wird.
 */
export default defineNuxtRouteMiddleware(async () => {
	const { ready } = useApp()

	await until(ready).toBe(true)
})
